import {Injectable} from '@angular/core';
import {SettingsService} from './settings.service';
import {map} from 'rxjs/operators';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
//import {PrepareParams} from '../common/prepare-params';
import {StorageService} from './storage.service';
import {Travel} from "app/models";
import * as moment from 'moment';

@Injectable()
export class TravelsService {
  apiUrl: string;
  token: string;
  // clientId: number;

  constructor(private http: HttpClient,
              private settings: SettingsService,
              private storage: StorageService) {
    this.apiUrl = this.settings.apiUrl;
    this.token = this.storage.accessToken;

  }

  getTravels(params): Observable<any> {

    const clientId = this.storage.userId;
    const filteredByClient = `client/${clientId}` ;
    const todayDate = moment().format('YYYY-MM-DD')
    // return this.http.get(`${this.apiUrl}/travels/${filteredByClient}?dateFrom=${todayDate}` ).pipe(map((resp: any) => {
      return this.http.get(`${this.apiUrl}/travels/${filteredByClient}` ).pipe(map((resp: any) => {

      return  resp.list.map((item) => {
        item.image = item.image ? `${this.apiUrl}/file/travel-image/${item.image}?token=${this.storage.accessToken}` : null;
          return new Travel().setFromApiModel(item);
        })

    }));
    return null;
  }


  getTravelsByType(params: any, status: string): Observable<any> {

    const clientId = this.storage.userId;
    const filteredByClient = `client/${clientId}` ;

    return this.http.get(`${this.apiUrl}/travels/${filteredByClient}?status=${status}` ).pipe(map((resp: any) => {

      return  resp.list.map((item) => {
        item.image = item.image ? `${this.apiUrl}/file/travel-image/${item.image}?token=${this.storage.accessToken}` : null;
        return new Travel().setFromApiModel(item);
      })

    }));
    return null;
  }

  getTravel(id): Observable<any> {
    return this.http.get(`${this.apiUrl}/public/travel/${id}`).pipe(map((resp: any) => {
      resp.image = resp.image ? `${this.apiUrl}/file/travel-image/${resp.image}?token=${this.storage.accessToken}` : null;

      return new Travel().setFromApiModel(resp);
    }));
  }
}
